import Litepicker from "litepicker";
import "litepicker/dist/css/litepicker.css";

const INMO_PICKER_SELECTOR = ".js-litepicker-inmo";
const INMO_VALUE_SELECTOR = ".js-litepicker-value";
const LITEPICKER_LOCALE = "es-CO";
const DEFAULT_MIN_YEAR = 1990;

function dispatchInputSync(hiddenInput) {
    hiddenInput.dispatchEvent(new Event("input", { bubbles: true }));
    hiddenInput.dispatchEvent(new Event("change", { bubbles: true }));
}

function formatIsoDate(date) {
    if (!date) return "";

    if (typeof date.format === "function") {
        return date.format("YYYY-MM-DD");
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
}

function formatDisplayDate(date) {
    if (!date) return "";

    if (typeof date.format === "function") {
        return date.format("DD/MM/YYYY", LITEPICKER_LOCALE);
    }

    return new Intl.DateTimeFormat(LITEPICKER_LOCALE, {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    }).format(date);
}


function initLitepickerInput(input) {
    if (input.dataset.lp === "true") return;

    const hiddenInput = input.parentElement?.querySelector(INMO_VALUE_SELECTOR);
    if (!hiddenInput) return;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // picker se asigna después del constructor; onRender usa rAF para leerlo
    let picker;

    try {
        picker = new Litepicker({
            element: input,
            singleMode: true,
            autoApply: true,
            allowRepick: true,
            autoRefresh: false,
            format: "DD/MM/YYYY",
            lang: LITEPICKER_LOCALE,
            firstDay: 1,
            startDate: hiddenInput.value || null,
            maxDate: today,
            dropdowns: {
                minYear: Number.parseInt(input.dataset.lpYearStart || String(DEFAULT_MIN_YEAR), 10),
                maxYear: today.getFullYear(),
                months: true,
                years: true,
            },
            lockDaysFilter(date) {
                return typeof date?.isAfter === "function"
                    ? date.isAfter(today, "day")
                    : false;
            },
            buttonText: {
                previousMonth:
                    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18"><path fill="currentColor" d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>',
                nextMonth:
                    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18"><path fill="currentColor" d="m8.59 16.59 1.41 1.41 6-6-6-6-1.41 1.41L13.17 12z"/></svg>',
            },
            // Invierte meses Dic→Ene sin romper event listeners (prepend no toca el <select>)
            onRender(pickerEl) {
                const monthSel = pickerEl.querySelector("select.month-item-name");
                if (!monthSel) return;
                const current = monthSel.value;
                [...monthSel.options].forEach((opt) => monthSel.prepend(opt));
                monthSel.value = current;
            },
            setup(pickerInstance) {
                pickerInstance.on("selected", (selectedDate) => {
                    hiddenInput.value = formatIsoDate(selectedDate);
                    input.value = formatDisplayDate(selectedDate);
                    dispatchInputSync(hiddenInput);
                });
            },
        });
    } catch (error) {
        console.error("No se pudo inicializar Litepicker", error);
        input.dataset.lpError = "true";
        return;
    }

    if (hiddenInput.value) {
        input.value = formatDisplayDate(picker.getDate());
    }

    input.dataset.lp = "true";
    input._litepicker = picker;
}

window.initDatepickers = function initDatepickers(root = document) {
    root.querySelectorAll(`${INMO_PICKER_SELECTOR}:not([data-lp])`).forEach((input) => {
        initLitepickerInput(input);
    });
};

function bootstrapDatepickers() {
    try {
        window.initDatepickers();
    } catch (error) {
        console.error("No se pudieron inicializar los datepickers", error);
    }
}

document.addEventListener("alpine:initialized", () => {
    setTimeout(bootstrapDatepickers, 50);
});

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootstrapDatepickers);
} else {
    bootstrapDatepickers();
}

const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
            if (!(node instanceof HTMLElement)) return;

            if (node.matches(`${INMO_PICKER_SELECTOR}:not([data-lp])`)) {
                window.initDatepickers(node.parentElement || node);
                return;
            }

            if (node.querySelector(`${INMO_PICKER_SELECTOR}:not([data-lp])`)) {
                window.initDatepickers(node);
            }
        });
    });
});

observer.observe(document.body, {
    childList: true,
    subtree: true,
});
